import { HelpCenterFaq } from './HelpCenterType';

export const helpCenterTitle = '圆领 Q&A';

export const helpCenterFaqs: HelpCenterFaq[] = [
  {
    question: '为什么选择圆领平台？',
    answers: [
      '圆领平台是中国目前最大的个人技能电商交易平台。平台有以下承诺性规则：',
      '1、交易发生在平台上，资金安全由平台保障；买家支付订单后，钱托管在平台，而不是直接进入卖家的账户。在服务验收完成之前，卖家都无法对该笔资金做任何操作。',
      '2、服务开启之前，可无理由退款，资金即刻原路返回。一旦买家确认开启服务，意味着卖家已经开始投入精力和时间，此时不再提供无理由退款，如遇问题双方应当友好协商解决。',
      '3、服务后不满意可以拒绝验收（意味着拒绝付款），双方友好协商解决方案，平台会发挥积极调节作用；若多方调节无果的，双方可通过法律手段解决，平台会客观的提供相关证据，不偏袒任何一方。',
      '4、圆领卖家自担基础生产资料，企业无需办公场地、无需配备电脑，平台按照国家相关法律法规负责为个体卖家（灵活就业者）完税，并且给为付费企业开具发票（普通/增值税专用发票均支持）。',
    ],
  },
  {
    question: '购买有哪些需要注意的事项？',
    answers: [
      '1、请务必在平台完成订单支付和跟进，非平台交易不仅没有保障，而且是平台红线行为，平台查证后将会对买卖双方进行永久封号处理并向买家公司注册地址发送律师函。任何与平台认识的卖家进行非平台的服务交易资金往来都属于线下交易。',
      '2、请在购买前务必与卖家明确好自身的需求，不要为了压价刻意掩盖需求难度和细节。圆领已经比正式员工的综合成本要低很多，合理还价、抵制内卷。',
      '3、圆领的价格已经远低于传统正式员工或者线下劳务派遣外包，请不要抱有以极低的、不合理的价格获得高质量服务的幻想。这是导致纠纷的最主要的原因之一，一味贪图便宜者不建议使用圆领，过度用无报酬、低价打扰卖家者可能会被禁用账号。',
      '4、服务开启后，如果双方产生纠纷，平台会充分发挥积极调节作用；常规情况下各行各业的交付成果质量标准太多，平台很难决定谁更有道理，一般不会轻易替双方做决策。但如果一方有明显的、有意的过失（故意失踪、恶意捏造事实、违反平台红线等），平台会做强制处理。',
    ],
  },
  {
    question: '我的钱是直接付给卖家的吗？',
    answers: [
      '买家预订服务后，服务款项由平台托管。服务交付完成后，经买家确认验收（为了防止恶意不验收，如卖家发起验收后买家7天内无任何回应，平台会自动完成验收），服务款项才会转至卖家在平台的资金账户。因此，为了保障你的资金安全，所有付款请在圆领平台进行。在平台外向卖家付款，平台不仅无法提供任何保障，我方还会向买家公司注册地址发送律师函，追缴服务费。若你被卖家要求在平台外付款，请立刻反馈至平台，在【我-联系我们】中联系客服。',
    ],
  },
  {
    question: '平台自营商品相比普通商品有何优势？',
    answers: [
      '1、自营类商品分为两类：自营任务制商品和自营按月承揽商品。',
      '2、自营任务制商品交易中，平台会对交付结果负责，圆领平台工作团队是全国最懂远程项目管理的团队之一，通过健康、高效的项目管理，您或许可以省下很多的资金和时间。如果您的项目较大，质量要求较高，并且您对个人卖家不够信任，就可以购买自营商品。截止目前（2024年3月），自营任务制服务零差评。',
      '3、自营按月承揽商品中，平台会负责代客户招募价格合适、能力相符的人才，企业也可以按照自己的需求进一步面试。按月承揽用于连续高频的任务场景，如果每次都要创建订单会十分繁琐，按月承揽类似于商品包月，在自然月中人才听从客户员工的指示，远程的完成工作任务。人才与客户企业之间没有劳动法律关系，终止合作无需赔偿金。平台负责统一的人才管理（招聘、面试）、远程上岗培训、酬劳发放管理。',
    ],
  },
  {
    question: '平台可以开发票吗？',
    answers: [
      '可以。无论个人支付/企业余额支付，在圆领平台购买服务均可开具发票（个人代公司付款走企业报销时也可申请开具普通/增值税专用发票）。发票类型、抬头类型可按需选择，买家可在交易完成后的任意时间申请开票，平台会在收到申请后5-7个工作日内处理开票事宜。发票开具申请路径：登录【圆领App】-【我的】-【开具发票】。',
    ],
  },
  {
    question: '如何了解服务的进展？',
    answers: [
      '打开圆领App，在“订单”列表中找到所购买的技能服务订单。点击进入后，可以查看该卖家提交的服务进展。或者您也可以通过平台提供的聊天功能询问卖家工作者。',
    ],
  },
];
